import React, { useEffect, useState } from 'react';
import { StyledWidget, StyledWidgetWrapper } from './UptimeChatWidget.style';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { DEFAULT_INDEX, useChatWidget } from 'containers/ChatWidgetContainer';
import { TOP_NAV_HEIGHT, TOP_NAV_Z_INDEX } from 'components/TopNav/TopNav.style';

const UptimeChatWidget = () => {
  const { jsLoaded } = useChatWidget();
  const { currentUser } = useSelector((state: RootState) => state.baseReducer);
  const { generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );
  const [customStyle, setCustomStyle] = useState({
    right: 0,
    bottom: 10,
    zIndex: DEFAULT_INDEX,
  });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [reloadPos, setReloadPos] = useState(true);
  const styledWidget = generalConfig?.asdChatWidget?.styledWidget;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const wrapperContainer = document.getElementById('dv-topnav-wrapper_container');
  const widget = document.getElementById('widget');
  const widgetBuble = document.getElementById('widget_bubble');

  const widgetClick = () => {
    setReloadPos(prev => !prev);
    setTimeout(() => {
      const widgetBtnConfirm = document.querySelector('#widget_btn_confirm');
      widgetBtnConfirm?.addEventListener('click', () => {
        ['top', 'left', 'transition', 'position', 'z-index', 'width', 'height'].forEach(prop => widget?.style.removeProperty(prop));
      });
    }, 100);
  };

  useEffect(() => {
    if (!currentUser || !styledWidget?.right || !jsLoaded) return;
    const secondaryMenu = document.querySelector('.marketplace-menu');

    const wrapperContainerRight = wrapperContainer?.getBoundingClientRect()?.right ?? 0;
    const widgetWidth = widget?.getBoundingClientRect()?.width ?? 0;
    const widgetTop = widget?.getBoundingClientRect()?.top ?? 0;
    const primaryMenuBottom = wrapperContainer?.getBoundingClientRect()?.bottom ?? 0;
    const secondaryMenuBottom = secondaryMenu?.getBoundingClientRect()?.bottom ?? 0;

    const isOverTop = widgetTop < (!!secondaryMenu ? secondaryMenuBottom : primaryMenuBottom);
    const isOverRight = wrapperContainerRight + widgetWidth > windowWidth;
    const isDragging = window.getComputedStyle(widget!).position === 'fixed';
    const isOverSecondMenu = !!secondaryMenu && secondaryMenuBottom > widgetTop && !!isDragging && !!widget;

    const rightCalc = isOverRight
      ? 0
      : windowWidth - wrapperContainerRight - widgetWidth + (!!widgetBuble ? styledWidget?.right : 0);

    setCustomStyle({
      ...styledWidget,
      right: rightCalc,
      zIndex: isOverTop ? TOP_NAV_Z_INDEX + 1 : styledWidget?.zIndex,
    });

    if(isOverSecondMenu) {
      widget.style.top = `${widgetTop + TOP_NAV_HEIGHT}px`;
    };
  }, [window.location.pathname, currentUser, reloadPos, jsLoaded, windowWidth, windowHeight, styledWidget, widgetBuble]);


  useEffect(() => {
    if (!currentUser || !jsLoaded) return;
    widget?.addEventListener('click', widgetClick);
  }, [currentUser, jsLoaded]);

  return (
    <StyledWidgetWrapper zIndex={customStyle?.zIndex} id="widget-wrapper">
      <StyledWidget
        widget={customStyle}
        id="widget"
      ></StyledWidget>
    </StyledWidgetWrapper>
  );
};

export default UptimeChatWidget;